"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAdapter = void 0;
var observable_1 = require("../helper/observable");
var utils_1 = require("../utils/utils");
var BaseAdapter = /** @class */ (function (_super) {
    __extends(BaseAdapter, _super);
    function BaseAdapter() {
        return _super.call(this) || this;
    }
    BaseAdapter.prototype.current = function (callback) {
        throw new Error('The `current` method must be defined in child classes.');
    };
    BaseAdapter.prototype.query = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        throw new Error('The `query` method must be defined in child classes.');
    };
    BaseAdapter.prototype.binding = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // Can be implemented in subclasses
    };
    BaseAdapter.prototype.destroy = function () {
        // Can be implemented in subclasses
    };
    BaseAdapter.prototype.generateResultId = function (container, data) {
        var id = container.id + '-result-';
        id += utils_1.Utils.generateChars(4);
        if (data.id != null) {
            id += '-' + data.id.toString();
        }
        else {
            id += '-' + utils_1.Utils.generateChars(4);
        }
        return id;
    };
    return BaseAdapter;
}(observable_1.Observable));
exports.BaseAdapter = BaseAdapter;
//# sourceMappingURL=base.js.map